var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAttachmenticon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10.571,
    height: 19.764,
    viewBox: "0 0 10.571 19.764",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "attachment_3_",
    "data-name": "attachment (3)",
    transform: "translate(-12.5 -2.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38133",
    "data-name": "Path 38133",
    d: "M23.071,16.978V8.7a.689.689,0,0,0-1.379,0v8.273a3.907,3.907,0,1,1-7.814,0V6.407a2.528,2.528,0,0,1,5.056,0v9.882a1.149,1.149,0,1,1-2.3,0V7.326a.689.689,0,1,0-1.379,0v8.963a2.528,2.528,0,0,0,5.056,0V6.407a3.907,3.907,0,0,0-7.814,0V16.978a5.286,5.286,0,0,0,10.571,0Z",
    transform: "translate(0 0)",
    fill: "#4a5174"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttachmenticon);
export default __webpack_public_path__ + "static/media/attachment icon.ca9cc51c.svg";
export { ForwardRef as ReactComponent };